import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  ViewChild,
} from '@angular/core'

@Component({
  selector: 'basin-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
})
export class ListItemComponent implements OnChanges, AfterViewInit {
  @ViewChild('leftSection') leftSection: ElementRef
  @ViewChild('rightSection') rightSection: ElementRef
  @ViewChild('centerSection') centerSection: ElementRef
  @ViewChild('primaryLineSection') primaryLineSection: ElementRef
  @ViewChild('secondaryLineSection') secondaryLineSection: ElementRef
  @ViewChild('tertiaryLineSection') tertiaryLineSection: ElementRef
  @HostBinding() tabindex = 0
  @Input() selected = false
  @Input() primaryLine: string
  @Input() secondaryLine: string
  @Input() tertiaryLine: string
  @Input() textboxCenterAligned: boolean = false
  @Input() mobileFullWidthImage: boolean = false
  mobileFullWidthImageClass: string
  imagePaddingClass: string
  centerAlignLineClass: string
  selectedClass: string
  leftContentClass: string
  centerContentClass: string
  primaryLineContainsContent: boolean = true
  secondaryLineContainsContent: boolean = true
  tertiaryLineContainsContent: boolean = true

  constructor(private cdRef: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this.checkForLineContent()
    this.imageCheck()
    this.oneLineCheck()
    this.selectedCheck()
    this.mobileFullWidthImageCheck()
    this.leftContentCheck()
    this.centerContentCheck()
    this.cdRef.detectChanges()
  }

  ngOnChanges() {
    this.selectedCheck()
  }

  checkForLineContent() {
    this.primaryLineContainsContent =
      this.primaryLine != undefined ||
      Array.from(this.primaryLineSection.nativeElement.children).length > 0
    this.secondaryLineContainsContent =
      this.secondaryLine != undefined ||
      Array.from(this.secondaryLineSection.nativeElement.children).length > 0
    this.tertiaryLineContainsContent =
      this.tertiaryLine != undefined ||
      this.tertiaryLineSection.nativeElement.children.length > 0
  }

  selectedCheck() {
    if (this.selected) {
      this.selectedClass = 'selected'
    } else {
      this.selectedClass = ''
    }
  }

  oneLineCheck() {
    if (
      (this.primaryLineContainsContent &&
        !this.secondaryLineContainsContent &&
        !this.tertiaryLineContainsContent) ||
      this.textboxCenterAligned
    ) {
      this.centerAlignLineClass = 'textbox-center-alignment'
    } else {
      this.centerAlignLineClass = ''
    }
  }

  mobileFullWidthImageCheck() {
    if (this.mobileFullWidthImage) {
      this.mobileFullWidthImageClass = 'mobile-full-width-image'
    } else {
      this.mobileFullWidthImageClass = ''
    }
  }

  imageCheck() {
    let leftChildren = Array.from(this.leftSection.nativeElement.children)
    let rightChildren = Array.from(this.rightSection.nativeElement.children)
    if (
      leftChildren.some((element: any) => {
        return element.tagName === 'IMG'
      }) ||
      rightChildren.some((element: any) => {
        return element.tagName === 'IMG'
      })
    ) {
      this.imagePaddingClass = 'image-padding-class'
    } else {
      this.imagePaddingClass = ''
    }
  }

  leftContentCheck() {
    let leftChildren = Array.from(this.leftSection.nativeElement.children)
    if (leftChildren.length > 0) {
      this.leftContentClass = 'left-content-filled'
    } else {
      this.leftContentClass = ''
    }
  }

  centerContentCheck() {
    let centerChildren = Array.from(this.centerSection.nativeElement.children)
    if (centerChildren.length > 0) {
      this.centerContentClass = 'center-content-filled'
    } else {
      this.centerContentClass = ''
    }
  }
}
